import React, { Component } from 'react';
import { Container, Link } from '@mui/material';
import { withTranslation } from 'react-i18next';
import axios from 'axios';

class TestShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: localStorage.getItem('LANG')
    }
  }

  showCatalog = () => {
    

    axios.get('http://192.168.1.111:3001/v1/view/products').then(response => {
      window.location.href = response.data.redirect;
    })
  }

  showOrders = () => {
    

    axios.get('http://192.168.1.111:3001/v1/view/orders').then(response => {
      window.location.href = response.data.redirect;
    })
  }

  getOrders = () => {
    

    axios.get('http://192.168.1.111:3001/v1/orders').then(response => {
      console.log(response.data)
    })
  }

  getProducts = () => {
    

    axios.get('http://192.168.1.111:3001/v1/products').then(response => {
      console.log(response.data)
    })
  }

  getSubs = () => {
    

    axios.get('http://192.168.1.111:3001/v1/products').then(response => {
      console.log(response.data)
    })
  }

  componentDidMount() {
  }

  render() {
    return (
      <Container sx={{ p: 2, mt:14 }}>
        <Link sx={{mt:14}} onClick={this.showCatalog}>go to catalog</Link>
        <br/>
        <Link sx={{mt:14}} onClick={this.showOrders}>go to orders</Link>
        <br/>
        <Link sx={{mt:14}} onClick={this.getOrders}>get orders</Link>
        <br/>
        <Link sx={{mt:14}} onClick={this.getProducts}>get products</Link>
        <br/>
        <Link sx={{mt:14}} onClick={this.getSubs}>get subs</Link>
      </Container>
    );
  }
}

export default withTranslation()(TestShop);